interface CalendarEvent {
  title: string;
  description: string;
  startTime: Date;
  endTime: Date;
  location: string;
}

export function generateCalendarUrls(event: CalendarEvent) {
  const formatTime = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  // Format dates for URLs
  const start = formatTime(event.startTime);
  const end = formatTime(event.endTime);
  
  // Encode text for URLs
  const title = encodeURIComponent(event.title);
  const description = encodeURIComponent(event.description);
  const location = encodeURIComponent(event.location);

  return {
    google: `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${start}/${end}&details=${description}&location=${location}`,
    outlook: `https://outlook.live.com/calendar/0/deeplink/compose?subject=${title}&startdt=${event.startTime.toISOString()}&enddt=${event.endTime.toISOString()}&body=${description}&location=${location}`,
    yahoo: `https://calendar.yahoo.com/?v=60&title=${title}&st=${start}&et=${end}&desc=${description}&in_loc=${location}`,
    ics: `data:text/calendar;charset=utf8,${encodeURIComponent(generateICSFile({
      title: event.title,
      date: event.startTime,
      duration: String(Math.round((event.endTime.getTime() - event.startTime.getTime()) / 60000)),
      location: event.location,
    }))}`
  };
}

export function generateICSFile(meeting: {
  title: string;
  date: Date;
  duration: string;
  location: string;
}) {
  const startTime = new Date(meeting.date);
  const endTime = new Date(startTime.getTime() + parseInt(meeting.duration) * 60000);

  const formatDate = (date: Date) => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Meeting Scheduler//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:REQUEST',
    'BEGIN:VEVENT',
    `DTSTART:${formatDate(startTime)}`,
    `DTEND:${formatDate(endTime)}`,
    `SUMMARY:${meeting.title}`,
    `LOCATION:${meeting.location}`,
    'STATUS:CONFIRMED',
    'SEQUENCE:0',
    `UID:${Date.now()}@meetingscheduler.com`,
    'BEGIN:VALARM',
    'TRIGGER:-PT15M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Reminder',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  return icsContent;
}